import { ITariffDiscount } from "@interfaces/admin/tariff"
import { useSwitchPercentStatusMutation } from "@RTKQuery/admin/customers/customers"
import { Input, Button } from "@ui"
import { FormikProps, Formik } from "formik"
import { forwardRef } from "react"
import { Form, useParams } from "react-router-dom"
import style from "./Tariff.module.scss";
import * as Yup from 'yup';
import cn from "classnames";

type TariffForm = {
    "3": string,
    "7": string,
    "30": string,
} & {
    [key: string]: string
};

const Tariff = forwardRef<FormikProps<TariffForm>, { colorCircle: string, data: ITariffDiscount }>(({
    colorCircle,
    data
}, ref) => {
    return (
        <div className={style.tariff}>
            <div className={style.header}>
                <div className={cn("w-[15px] h-[15px] rounded-full", colorCircle)}></div>
                <p className={style.tariffName}>{data.name}</p>
            </div>
            <div className={style.body}>
                <Formik
                    initialValues={{
                        "3": String(data.personal_prices.find(item => item.rent_time === 3)?.price || data.rental_periods.find(item => item.rent_time === 3)?.price || ""),
                        "7": String(data.personal_prices.find(item => item.rent_time === 7)?.price || data.rental_periods.find(item => item.rent_time === 7)?.price || ""),
                        "30": String(data.personal_prices.find(item => item.rent_time === 30)?.price || data.rental_periods.find(item => item.rent_time === 30)?.price || ""),
                    }}
                    validationSchema={Yup.object({
                        "3": data.personal_prices.find(item => item.rent_time === 3)?.is_percent
                            ? Yup.number().typeError("Тільки числа").max(100, "Максимум 100%")
                            : Yup.number().typeError("Тільки числа"),
                        "7": data.personal_prices.find(item => item.rent_time === 7)?.is_percent
                            ? Yup.number().typeError("Тільки числа").max(100, "Максимум 100%")
                            : Yup.number().typeError("Тільки числа"),
                        "30": data.personal_prices.find(item => item.rent_time === 30)?.is_percent
                            ? Yup.number().typeError("Тільки числа").max(100, "Максимум 100%")
                            : Yup.number().typeError("Тільки числа"),
                    })}
                    enableReinitialize
                    innerRef={ref}
                    onSubmit={(values) => { }}
                >
                    {(props) => (
                        <Form>
                            <div className="flex flex-col gap-[28px]">
                                <div className="flex relative justify-between items-center">
                                    <div className={style.inputLabel}>Три дня:</div>
                                    <Input
                                        label="Вартість"
                                        type="text"
                                        onChange={(newValue) => {
                                            props.setFieldValue("3", newValue.trim())
                                        }}
                                        onBlur={props.handleBlur}
                                        value={String(props.values["3"])}
                                        name="3"
                                        customStyle={{
                                            width: "!max-w-[50%]"
                                        }}
                                        error={props.touched["3"] ? props.errors["3"] : ""}
                                    />
                                    <div className="absolute left-full pl-[5px]">
                                        <PercentButton data={data.personal_prices.find(item => item.rent_time === 3)} />
                                    </div>
                                </div>
                                <div className="flex relative justify-between items-center">
                                    <div className={style.inputLabel}>Тиждень:</div>
                                    <Input
                                        label="Вартість"
                                        type="text"
                                        onChange={(newValue) => {
                                            props.setFieldValue("7", newValue.trim())
                                        }}
                                        onBlur={props.handleBlur}
                                        value={String(props.values["7"])}
                                        name="7"
                                        customStyle={{
                                            width: "!max-w-[50%]"
                                        }}
                                        error={props.touched["7"] ? props.errors["7"] : ""}
                                    />
                                    <div className="absolute left-full pl-[5px]">
                                        <PercentButton data={data.personal_prices.find(item => item.rent_time === 7)} />
                                    </div>
                                </div>
                                <div className="flex relative justify-between items-center">
                                    <div className={style.inputLabel}>Місяць:</div>
                                    <Input
                                        label="Вартість"
                                        type="text"
                                        onChange={(newValue) => {
                                            props.setFieldValue("30", newValue.trim())
                                        }}
                                        onBlur={props.handleBlur}
                                        value={String(props.values["30"])}
                                        name="30"
                                        customStyle={{
                                            width: "!max-w-[50%]"
                                        }}
                                        error={props.touched["30"] ? props.errors["30"] : ""}
                                    />
                                    <div className="absolute left-full pl-[5px]">
                                        <PercentButton data={data.personal_prices.find(item => item.rent_time === 30)} />
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    )
})

function PercentButton({
    data
}: {
    data: ITariffDiscount["personal_prices"][0] | undefined
}) {
    const { id } = useParams();

    const [switchPercentStatus, { isLoading }] = useSwitchPercentStatusMutation();

    if (data) {
        return (
            <Button
                type="button"
                form="rectangle"
                text="%"
                customStyle={{
                    button: "!p-[5px] !w-[24px] !h-[32px]",
                }}
                variant={data.is_percent ? "filled" : "outline"}
                loading={isLoading}
                onClick={() => {
                    switchPercentStatus({
                        params: {
                            user_id: Number(id)
                        },
                        personal_price_id: data.id,
                        new_status: !data.is_percent
                    })
                }}
            />
        )
    } else {
        return null
    }
}

export { Tariff }